/** Build WhatsApp deep link (prefilled text only; attachments are manual in the app). */
export function whatsappUrl(phone, text) {
  let n = String(phone || '').replace(/\D/g, '');
  if (n.length === 10) n = `91${n}`;
  if (!n) return '#';
  const q = text ? `?text=${encodeURIComponent(text)}` : '';
  return `https://wa.me/${n}${q}`;
}

/** Store WhatsApp number (E.164 digits only, e.g. 9190...). */
export const STORE_WHATSAPP_E164 =
  (process.env.REACT_APP_STORE_WHATSAPP_E164 || '').replace(/\D/g, '') || '919092355957';
